// MOTH's pinned chapter timing and layout, scoped to Radio Relay's existing media.
if (!customElements.get('relay-scroll')) {
  customElements.define('relay-scroll', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      const sequence = this.querySelector('.relay-scroll-track');
      const stories = [...this.querySelectorAll('.relay-scroll-story')];
      if (!sequence || stories.length < 2) return;
      const stage = sequence.querySelector('.relay-scroll-stage');
      const steps = [...sequence.querySelectorAll('button')];
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let active = -1, enabled = false, travel = 0, top = 0, inView = false;
      const syncVideos = () => stories.forEach((story, index) => {
        story.querySelectorAll('video').forEach(video => {
          video.controls = !enabled;
          if (enabled && inView && index === active) video.play().catch(() => {});
          else video.pause();
        });
      });
      const activate = index => {
        if (index === active) return;
        active = index;
        sequence.dataset.chapter = String(index + 1);
        stories.forEach((story, i) => {
          story.classList.toggle('is-active', i === index);
          story.setAttribute('aria-hidden', String(i !== index));
          story.inert = i !== index;
        });
        steps.forEach((button, i) => {
          if (i === index) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });
        syncVideos();
      };
      const update = () => {
        this.scrollFrame = null;
        if (!enabled) return;
        const progress = Math.max(0, Math.min(1, (top - sequence.getBoundingClientRect().top) / travel));
        activate(Math.min(stories.length - 1, Math.floor(progress * stories.length)));
      };
      const request = () => {
        if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(update);
      };
      const layout = () => {
        sequence.classList.add('is-enhanced');
        const height = Math.ceil(stage.getBoundingClientRect().height);
        top = Math.min(innerWidth < 750 ? 76 : 100, innerHeight - height - 20);
        sequence.style.setProperty('--relay-scroll-top', `${top}px`);
        enabled = !reducedMotion.matches;
        sequence.classList.toggle('is-enhanced', enabled);
        if (enabled) {
          travel = Math.round(innerHeight * .8 * stories.length);
          sequence.style.height = `${height + travel}px`;
          stories.forEach(story => story.querySelectorAll('img').forEach(image => { image.loading = 'eager'; }));
          active = -1;
          update();
        } else {
          sequence.style.removeProperty('height');
          stories.forEach(story => {
            story.removeAttribute('aria-hidden');
            story.inert = false;
          });
          syncVideos();
        }
      };
      steps.forEach((button, index) => button.addEventListener('click', () => {
        if (!enabled) return;
        const start = scrollY + sequence.getBoundingClientRect().top - top;
        window.scrollTo({ top: start + travel * (index + .5) / stories.length, behavior: 'smooth' });
      }, { signal }));
      window.addEventListener('scroll', request, { passive: true, signal });
      window.addEventListener('resize', layout, { passive: true, signal });
      window.addEventListener('pageshow', layout, { signal });
      window.addEventListener('load', layout, { signal });
      this.stageObserver = new ResizeObserver(() => {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(layout);
      });
      this.stageObserver.observe(stage);
      this.visibilityObserver = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        syncVideos();
      });
      this.visibilityObserver.observe(stage);
      reducedMotion.addEventListener('change', layout, { signal });
      document.addEventListener('shopify:block:select', event => {
        const index = stories.findIndex(story => story === event.target || story.contains(event.target));
        if (enabled && index >= 0) steps[index].click();
      }, { signal });
      layout();
      document.fonts.ready.then(() => { if (!signal.aborted) layout(); });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.stageObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      cancelAnimationFrame(this.layoutFrame);
      cancelAnimationFrame(this.scrollFrame);
      this.querySelectorAll('video').forEach(video => video.pause());
      this.scrollFrame = null;
    }
  });
}
